import { Component, Fragment } from 'react';

import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from '@mui/icons-material';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, Pagination, TableCell } from '@mui/material';
import moment from 'moment';
import { withRouter } from 'providers';
import Moment from 'react-moment';

import AxlTable from '../../../components/JTable';
import { API_REQUESTING, api } from '../../../stores/api';
import { lightTheme } from '../../../themes';
import { StyledAxlPanel, StyledLabel } from '../styles';
import * as E from './styles';
import { MoreLink } from './styles';

const headerStyle = { backgroundColor: lightTheme.palette.primary.main, color: lightTheme.palette.primary.contrastText, fontWeight: 900, whiteSpace: 'nowrap' };

const styles = {
  content: {
    fontFamily: 'AvenirNext',
    padding: '0 24px 16px',
    fontSize: 12,
    position: 'relative',
    '& > .MuiGrid-root': {
      marginTop: '10px',
      width: '100%',
    },
  },
  box: {
    paddingTop: '8px',
  },
  title: {
    fontFamily: 'AvenirNext-Bold',
    fontSize: 18,
    fontWeight: 'bold',
  },
};
class EventList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      size: 20,
      totalResult: 0,
      selectedRouteDetail: null,
      selectedPaymentDetail: null,
    };
    this.assignmentDetailFields = [
      { label: 'Assignment', key: 'label' },
      { label: 'Assignment Date', key: 'assignmentDate' },
      { label: 'Driver', key: 'driver' },
      { label: 'Shipments no.', key: 'shipmentNo' },
      { label: 'Failed Shipments', key: 'shipmentFailed' },
      { label: 'Clients', key: 'clientName' },
    ];
    this.listDetailFields = [
      { label: 'Driver', key: 'driver_id' },
      { label: 'Driver Name', key: 'driver_name' },
      { label: 'Assignment IDs', key: 'assignment_ids' },
      { label: 'Total Records', key: 'count' },
      { label: 'Total Amount', key: 'total_amount', prefix: '$' },
    ];
  }

  renderRepaidPayments = (paymentDetails) => {
    const { selectedPaymentDetail } = this.state;
    return (
      <E.Table>
        <AxlTable>
          <AxlTable.Header>
            <AxlTable.Row>
              <AxlTable.HeaderCell style={headerStyle}>Repaid On</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Last Updated</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Status</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Repaid By</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Account #</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Routing #</AxlTable.HeaderCell>
            </AxlTable.Row>
          </AxlTable.Header>
          <AxlTable.Body>
            {paymentDetails.supplement_payments.map((supplementPayment) => {
              let IconTag = VisibilityIcon;
              if (selectedPaymentDetail === supplementPayment.id) {
                IconTag = VisibilityOffIcon;
              }
              return (
                <Fragment key={supplementPayment.id}>
                  <AxlTable.Row>
                    <AxlTable.Cell>
                      <Moment interval={0} format="YYYY-MM-DD HH:mm">
                        {supplementPayment._created}
                      </Moment>
                    </AxlTable.Cell>
                    <AxlTable.Cell>
                      {supplementPayment._updated ? (
                        <Moment interval={0} format="YYYY-MM-DD HH:mm">
                          {paymentDetails._updated}
                        </Moment>
                      ) : (
                        <span>N/A</span>
                      )}
                    </AxlTable.Cell>
                    <AxlTable.Cell>
                      <Box mr={1} component="span">
                        {supplementPayment.status}
                      </Box>
                      {supplementPayment.requestErrorContent && (
                        <IconTag
                          style={{ verticalAlign: 'text-bottom', cursor: 'pointer' }}
                          color="primary"
                          fontSize="small"
                          onClick={() =>
                            this.setState({ selectedPaymentDetail: supplementPayment.id === selectedPaymentDetail ? null : supplementPayment.id })
                          }
                        />
                      )}
                    </AxlTable.Cell>
                    <AxlTable.Cell>{supplementPayment.payer_username}</AxlTable.Cell>
                    <AxlTable.Cell>{supplementPayment.account_number}</AxlTable.Cell>
                    <AxlTable.Cell>{supplementPayment.routing_number}</AxlTable.Cell>
                  </AxlTable.Row>
                  {selectedPaymentDetail === supplementPayment.id && (
                    <AxlTable.Row>
                      <AxlTable.Cell colSpan={6} style={{ backgroundColor: '#f5f5f5' }}>
                        <Box m={1} p={2} style={{ backgroundColor: '#fff' }}>
                          {supplementPayment.requestErrorContent}
                        </Box>
                      </AxlTable.Cell>
                    </AxlTable.Row>
                  )}
                </Fragment>
              );
            })}
          </AxlTable.Body>
        </AxlTable>
      </E.Table>
    );
  };

  loadAssignmentDetail(ct) {
    this.setState({ isLoadingAssignment: true });
    api.get(`/dsp/assignments/${ct.assignment_id}/detail`).then((resp) => {
      if (resp.ok && resp.data) {
        const { assignmentLabel, clients, driver, assignment, stops } = resp.data;
        const stopFail = stops.filter((s) => s.type === 'DROP_OFF' && s.status === 'FAILED');
        const clientName = clients && clients.length > 0 ? clients.map((c) => c.company).join('\r\n') : '-';
        const detail = {
          id: ct.id,
          assignment_id: ct.assignment_id,
          label: assignmentLabel?.prefix || assignment.label || '-',
          assignmentDate: moment(assignment.predicted_start_ts).format('YYYY-MM-DD') || '',
          driver: `${driver.first_name} ${driver.last_name}`,
          shipmentNo: assignment.shipment_count,
          shipmentFailed: stopFail.length,
          clientName,
          type: ct.type,
          amount: ct.amount,
        };
        this.setState({ selectedRouteDetail: detail, isLoadingAssignment: false });
      }
    });
  }

  viewAssignmentDetails(e, assignmentId) {
    e.preventDefault();
    const { paymentDetails } = this.props;
    const assignment = paymentDetails.assignments.filter((a) => a.id === assignmentId).shift();
    const assignmentDate = moment(assignment.predicted_start_ts).format('YYYY-MM-DD');
    this.props.history.push(`/routes/${assignmentDate}/all/${assignmentId}`);
  }

  renderTransactions = (paymentDetails) => {
    const { selectedRouteDetail, page, size } = this.state;
    const { pagination } = this.props;
    const { assignments, drivers, contractor_transactions } = paymentDetails;
    const style = { color: 'inherit' };
    // let viewedAssignment = null;
    let transactions = contractor_transactions;
    // if (selectedRouteDetail) {
    //   viewedAssignment = assignments.filter(a => a.id === selectedRouteDetail.assignment_id).shift();
    // }
    const pageCount = contractor_transactions.length > 0 && Math.ceil(contractor_transactions.length / size);
    if (pagination) {
      const from = Math.max(0, page - 1);
      const to = Math.min(page, pageCount);
      transactions = contractor_transactions.slice(from * size, to * size);
    }

    return (
      <E.Table>
        <AxlTable>
          <AxlTable.Header>
            <AxlTable.Row>
              <AxlTable.HeaderCell style={headerStyle}>Id</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Event Type</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Completed Time</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Amount</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Driver</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Note</AxlTable.HeaderCell>
              <AxlTable.HeaderCell style={headerStyle}>Details</AxlTable.HeaderCell>
            </AxlTable.Row>
          </AxlTable.Header>
          <AxlTable.Body>
            {transactions.map((ct) => {
              let driver;
              if (ct.assignment_id) {
                const assignment = assignments.filter((a) => a.id === ct.assignment_id).shift();
                driver = drivers && drivers.filter((dr) => dr.id === assignment.driver_id).shift();
              }
              return (
                <Fragment key={ct.id}>
                  <AxlTable.Row style={{ color: ct.type === 'PAYMENT - DEDUCT' ? 'red' : undefined }}>
                    <AxlTable.Cell style={style}>
                      <span>{ct.id}</span>
                    </AxlTable.Cell>
                    <AxlTable.Cell style={style}>
                      <span>{ct.type}</span>
                    </AxlTable.Cell>
                    <AxlTable.Cell style={style}>
                      <Moment interval={0} format="YYYY-MM-DD HH:mm">
                        {ct.actual_end_ts}
                      </Moment>
                    </AxlTable.Cell>
                    <AxlTable.Cell style={style}>
                      <span>{'$' + ct.amount}</span>
                    </AxlTable.Cell>
                    <AxlTable.Cell style={style}>
                      <span>{(driver && `${driver.first_name} ${driver.last_name}`) || ''}</span>
                    </AxlTable.Cell>
                    <AxlTable.Cell style={style}>
                      <span style={{ wordBreak: 'break-all' }}>{ct.notes}</span>
                    </AxlTable.Cell>
                    <AxlTable.Cell style={style}>
                      {(['OUTVOICE - SURCHARGE'].includes(ct.type) ||
                        (['OUTVOICE - ROUTE_DRIVING', 'OUTVOICE - TIP'].includes(ct.type) && !!ct.assignment_id)) && (
                        <MoreLink
                          onClick={() => {
                            if (['OUTVOICE - SURCHARGE'].includes(ct.type) === false) {
                              this.loadAssignmentDetail(ct);
                            }
                            this.setState({ selectedRouteDetail: selectedRouteDetail && selectedRouteDetail.id === ct.id ? null : ct });
                          }}
                        >
                          {selectedRouteDetail && selectedRouteDetail.id === ct.id ? 'Hide' : 'Show'} Details
                        </MoreLink>
                      )}
                    </AxlTable.Cell>
                  </AxlTable.Row>
                </Fragment>
              );
            })}
            <Dialog open={!!selectedRouteDetail} onClose={() => this.setState({ selectedRouteDetail: null })}>
              <DialogTitle sx={styles.title}>Event Detail</DialogTitle>
              <DialogContent sx={styles.content}>
                {this.state.isLoadingAssignment && (
                  <div style={{ position: 'absolute', top: '40%', left: '40%' }}>
                    <CircularProgress color="primary" size={30} />
                  </div>
                )}

                {['OUTVOICE - SURCHARGE'].includes(selectedRouteDetail?.type) ? (
                  (() => {
                    return (
                      <TableCell colSpan={5}>
                        <Box m={1} p={2} style={{ backgroundColor: '#fff', overflowX: 'auto' }}>
                          <table style={{ borderCollapse: 'collapse', width: '100%', fontFamily: 'AvenirNext', fontSize: 12, color: '#4a4a4a' }}>
                            <thead>
                              <tr>
                                {this.listDetailFields?.map((field, idx) => (
                                  <th
                                    key={`field-${idx}`}
                                    style={{
                                      borderBottom: '1px solid #ddd',
                                      padding: '8px',
                                      textAlign: 'left',
                                      backgroundColor: lightTheme.palette.primary.main,
                                      color: lightTheme.palette.primary.contrastText,
                                      fontWeight: 900,
                                    }}
                                  >
                                    {field.label}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {selectedRouteDetail?.driverGroups?.map((driverGroup, idx) => (
                                <tr key={`driverGroup-${idx}`} style={{ borderBottom: '1px solid #eee' }}>
                                  {this.listDetailFields.map((field) => (
                                    <td style={{ padding: '8px' }}>{driverGroup[field.key] || '-'}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </Box>
                      </TableCell>
                    );
                  })()
                ) : (
                  <Grid container spacing={2}>
                    <Grid size={8}>
                      Event Type: <b>"{selectedRouteDetail?.type}"</b>
                    </Grid>
                    <Grid size={4} style={{ textAlign: 'right' }}>
                      {'$' + selectedRouteDetail?.amount}
                    </Grid>
                    <Grid size={12}>
                      <Grid container style={{ backgroundColor: '#f5f5f5', padding: '8px 16px 16px 16px' }}>
                        {this.assignmentDetailFields.map((field) => (
                          <Grid key={field.key} size={4}>
                            <Box sx={styles.box}>{field.label}</Box>
                            <Box sx={styles.box}>
                              <strong style={{ whiteSpace: ['clientName'].includes(field.key) ? 'pre' : 'unset' }}>
                                {(selectedRouteDetail?.[field.key]) || (field.key === 'shipmentFailed' ? 0 : 'N/A')}
                              </strong>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                    <Grid size={12} justifyContent={'center'} alignItems={'center'} display={'flex'}>
                      <Button
                        size="small"
                        variant="outlined"
                        color="secondary"
                        onClick={(e) => this.viewAssignmentDetails(e, selectedRouteDetail.assignment_id)}
                      >
                        View in Dispatch
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </DialogContent>
            </Dialog>
          </AxlTable.Body>
        </AxlTable>
        {pagination && pageCount > 1 && (
          <Grid container justifyContent="center">
            <Box p={1}>
              <Pagination color="primary" size="small" align="center" count={pageCount} onChange={(e, page) => this.setState({ page })} />
            </Box>
          </Grid>
        )}
      </E.Table>
    );
  };

  render() {
    const { repayStatus, paymentDetails } = this.props;
    if (!paymentDetails) {
      return null;
    }

    return (
      <StyledAxlPanel style={{ marginBottom: 0 }}>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <StyledLabel>Events</StyledLabel>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex' }}>
                  <span>Total amount:</span>
                  <span style={{ paddingLeft: '5px', fontWeight: 'bold', fontFamily: 'AvenirNext-Bold' }}>{'$' + paymentDetails.amount}</span>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ flex: 1, position: 'relative', backgroundColor: repayStatus === API_REQUESTING ? '#ccc' : undefined }}>
                {repayStatus === API_REQUESTING && <CircularProgress />}
                {this.renderTransactions(paymentDetails)}
              </Box>
            </Box>
          </Box>
        </Box>
      </StyledAxlPanel>
    );
  }
}

export default withRouter(EventList);
